import axios from 'axios';
import { config } from '../config';

const axiosInstance = axios.create({
    baseURL: config.apiUrl,
    timeout: config.requestTimeout,
    headers: {
        'Content-Type': 'application/json',
    },
});

export default axiosInstance;